// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Hdxr","overflowing":"ReadFullNote_overflowing__3wOOm"};